import style from "./our-task.module.scss";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";
import { InView } from "react-intersection-observer";
import animations from "@styles/animations.module.scss";
import { IOurTask } from "../givingli.content";

type OurTaskProps = {
  ourTask: IOurTask;
}

const OurTask = ({ ourTask }: OurTaskProps) => {
  return (
    <SharedAnimation
      render={() => (
        <section
          className={`${style.section} ${style.section__info}`}
        >
          <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
              if (inView) {
                entry?.target.classList.add(animations.active);
              }
              return (
                <div ref={ref} className={`${style.section__info__wrapper} ${animations.scroll__animation}`}>
                  <div className={style.section__info__wrapper__content}>
                    <div
                      className={style.section__info__wrapper__content__title}
                    >
                      {ourTask.title}
                    </div>
                    <div
                      className={
                        style.section__info__wrapper__content__description
                      }
                    >
                      {ourTask.description.map((text, index) => (
                        <div
                          className={
                            style.section__info__wrapper__content__description__text
                          }
                          key={index}
                        >
                          {text}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className={style.section__info__wrapper__cards}>
                    {ourTask.cards.map((card, index) => (
                      <div
                        key={index}
                        className={style.section__info__wrapper__cards__item}
                      >
                        <div
                          className={
                            style.section__info__wrapper__cards__item__image
                          }
                        >
                          <Image
                            src={card.image}
                            alt="card icon"
                            layout="fill"
                          />
                        </div>
                        <div
                          className={
                            style.section__info__wrapper__cards__item__description
                          }
                        >
                          {card.description}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }}
          </InView>
        </section>
      )}
    />
  );
};

export default OurTask;
